import { Collapse, Tab, Tabs } from "@blueprintjs/core";
import omit from 'lodash/omit';
import React from "react";

import { ID } from "common/entities/IEntity";
import Loading from "common/fragments/Loading";
import NonIdealState from "common/fragments/NonIdealState";
import AutoForm from "core/components/AutoForm";
import { EntityEditWrapper } from "core/components/EntityEditWrapper";
import { FragmentLayout } from "core/components/FragmentLayout";
import { IPanelProps, Panel } from "core/decorators/Panel";
import AppToaster from "core/util/AppToaster";
import TokenSession from "core/util/session/TokenSession";
import KnowledgeBasePanelConfig from "../config/KnowledgeBasePanelConfig";
import constants from "../constants";
import GlossaryTermList from "../glossary/GlossaryTermList";
import { KnowledgeBase } from "../knowledgeBase/entities";
import * as kbFragments from "../knowledgeBase/KnowledgeBaseFragments";


const KbEditWrapper = EntityEditWrapper.ofType<KnowledgeBase>();

interface IKnowledgeBasePanelState {
	selected: ID;
}

@Panel({
	id: 'kb-glossary-panel',
	configClass: KnowledgeBasePanelConfig,
	pageParams: true
})
class KnowledgeBaseGlossaryPanel extends React.Component<IPanelProps<KnowledgeBasePanelConfig>, IKnowledgeBasePanelState> {

	public state = { selected: null };

	public render() {
		const { config, pageParams } = this.props;

		const params = {};

		if (config.knowledgeBaseGuid) {
			params['guid'] = config.knowledgeBaseGuid;
		} else {
			return (
				<NonIdealState
					title="No Knowledge Base Selected"
					description=""
				/>
			);
		}

		return (
			<KbEditWrapper
				canEdit={TokenSession.hasRoles('ROLE_ADMIN')}
				entity={KnowledgeBase}
				params={params}
				onBeforeSave={this.onBeforeSave}
				onAfterSave={this.onAfterSave}
				showButtonGroup={false}
				title={'Edit Glossary terms'}
			>
				{
					(args) => {

						if (args.loading) {
							return <Loading />;
						}

						if (!args.data) {
							return (
								<NonIdealState title="Invalid Knowledge Base" description="" />
							);
						}

						return (
							<div>
								<div style={{padding: '15px'}}>
									<GlossaryTermList
										knowledgeBaseId={args.data.id}
										canCreate={TokenSession.hasRoles('ROLE_ADMIN')}
										canDelete={TokenSession.hasRoles('ROLE_ADMIN')}
										canUpdate={TokenSession.hasRoles('ROLE_ADMIN')}
										showPaginationOptions
									/>	
								</div>
								<FragmentLayout
									fragments={kbFragments}
									layout={config.layout}
									props={{
										knowledgeBase: args.data,
										config,
										currentCategory: pageParams[constants.PARAM_CATEGORY_ID]
									}}
								/>
							</div>
						);
					}
				}
			</KbEditWrapper>
		);
	}

	private onBeforeSave = (data: KnowledgeBase) => {
		return omit(data, ['categories']);
	}

	private onAfterSave = () => {
		AppToaster.show({
			message: "Saved Successfully",
			intent: 'success'
		});
	}
}



// WEBPACK FOOTER //
// ./src/panels/kb/learnerGlossary/KnowledgeBaseGlossary.panel.tsx